import { useState } from "react";
import { addMusicSubscriber } from "../firebase/firebase-functions";
import MusicPlayer from "../components/MusicPlayer";
import SEO from "../components/SEO"; // Add this import
import "./music.css";

const Music = () => {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [error, setError] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (email) {
      try {
        const result = await addMusicSubscriber(email);

        if (result.success) {
          setIsSubscribed(true);
          setEmail("");

          // Reset success message after 3 seconds
          setTimeout(() => setIsSubscribed(false), 3000);
        } else {
          setError(result.error || "Something went wrong. Please try again.");
        }
      } catch (err) {
        setError("Something went wrong. Please try again.");
      } finally {
        // Reset success message after 3 seconds
        setTimeout(() => setIsSubscribed(false), 3000);
      }
    }
  };

  return (
    <>
      {/* Add SEO component */}
      <SEO
        title="Anjali Daswani Music - Latest Songs & Releases"
        description="Listen to Anjali Daswani's latest music including 'Girl on the Train' and 'Square 1'. Pop meets R&B with folk-inspired melodies. Stream on Spotify, Apple Music, and more."
        url="https://anjalidmusic.com/music"
        keywords="Anjali Daswani music, Girl on the Train, Square 1, pop R&B folk music, stream music, Spotify Apple Music"
        isMusicPage={true}
        genre={["Pop", "R&B", "Folk", "Alternative"]}
        logSchema={false} // Enable during development to test schema
      />

      <div className="music-page">
        {/* Hero Section */}
        <section className="music-hero-section">
          <div className="container">
            <div className="music-hero-content">
              <h1 className="music-title text-gradient">My Music</h1>
              <p className="music-subtitle">
                Stories told through song • Pop meets R&B with folk-inspired
                melodies
              </p>
            </div>
          </div>
        </section>

        {/* Music Player Section */}
        <section className="player-section">
          <div className="container">
            <h2>Current Releases</h2>
            <MusicPlayer />
          </div>
        </section>

        {/* YouTube Video Section */}
        <section className="video-section">
          <div className="container">
            <div className="video-content">
              <h2>Live Performance</h2>
              <p>Watch my performance at The New School</p>
              <div className="video-wrapper">
                <iframe
                  src="https://www.youtube.com/embed/jQ-Zi4ZqHps?si=1DsIm5onLLClnv0G&amp;start=528"
                  title="Anjali Daswani Live Performance"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* Newsletter Signup Section */}
        <section className="newsletter-section">
          <div className="container">
            <div className="newsletter-content">
              <h2>Stay in the Loop</h2>
              <p>
                Be the first to know when new music drops. Get exclusive
                updates, behind-the-scenes content, and early access to new
                releases.
              </p>

              {!isSubscribed ? (
                <form
                  onSubmit={handleSubscribe}
                  className="newsletter-signup-form"
                >
                  <div className="input-group">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email address"
                      className="email-input"
                      required
                    />
                    <button type="submit" className="btn-primary subscribe-btn">
                      Notify Me
                    </button>
                  </div>
                  <p className="privacy-note">
                    I respect your privacy. No spam, just music updates!
                  </p>
                </form>
              ) : (
                <div className="success-message">
                  <div className="success-icon">✓</div>
                  <h3>Welcome to the family!</h3>
                  <p>You'll be the first to hear about new releases.</p>
                </div>
              )}
              {error && <p> {error} </p>}
            </div>
          </div>
        </section>

        {/* Coming Soon Section */}
        <section className="coming-soon-section">
          <div className="container">
            <div className="coming-soon-content">
              <h2>More Music Coming Soon</h2>
              <p>
                I'm constantly creating and working on new stories to share.
                Follow along on social media for studio updates and sneak peeks
                of what's next.
              </p>
              <div className="social-preview">
                <span>Follow the journey:</span>
                <div className="social-links-preview">
                  <a
                    href="https://www.instagram.com/anjyyx/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-preview-link"
                  >
                    @anjyyx
                  </a>
                  <a
                    href="https://www.tiktok.com/@anjali.daswani"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-preview-link"
                  >
                    @anjali.daswani
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Music;
